import { render, staticRenderFns } from "./NewProcessDefinition.vue?vue&type=template&id=3015850d&scoped=true&"
import script from "./NewProcessDefinition.vue?vue&type=script&lang=js&"
export * from "./NewProcessDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015850d",
  null
  
)

export default component.exports